<script setup lang="ts">
import { defineProps } from 'vue'
import { useRouter } from "vue-router";

const props = withDefaults(defineProps<{
  icon?: string
}>(), {
  icon: "PhArrowLeft"
})

const router = useRouter()

const isBackButton = (): boolean => {
  return props.icon === "PhArrowLeft"
}

const goBack = (): void => {
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push('/')
  }
}
</script>

<template>
  <v-row justify="space-between" align="center">
    <v-col cols="12" sm="auto" class="d-flex align-center">
      <v-icon v-if="isBackButton()" @click="goBack" icon="PhArrowLeft" class="icon-size mr-4" />
      <v-icon v-else :icon="props.icon" class="icon-size mr-4" />
      <h2 class="font-weight-semi-bold">
        <slot />
      </h2>
    </v-col>
    <slot name="actions" />
  </v-row>
</template>

<style scoped>
.icon-size {
  font-size: 2.25rem;
}

.title-text {
  font-size: 2rem;
  font-weight: bold;
}
</style>
